<template>
  <b-container fluid class="p-0" :class="complete ? 'fullContent' : ''">
    <b-row v-if="loading || notificationLoading || activityDetailsLoading">
      <b-col class="px-md-3 px-lg-6 py-5 shadow bg-white" offset-xl="2" xl="8">
        <LoadingSpinner :message="`Loading Landowner Report ${$route.params.id || ''}`" />
      </b-col>
    </b-row>
    <LandownerReportForm v-else-if="started || adminEditing" />
    <Summary
      v-else-if="complete"
      :fullscreen="false"
    />
  </b-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LandownerReportForm from '@/components/landownerreport/LandownerReportForm.vue';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import Summary from '@/components/landownerreport/summary/Summary.vue';

export default {
  name: 'LandownerReport',
  components: {
    LandownerReportForm,
    LoadingSpinner,
    Summary,
  },
  created() {
    this.$store.dispatch('LandownerReport/getLandownerReport', this.$route.params.id)
      .then(() => this.$store.dispatch('Notification/getNotification', this.landownerReport.notificationId)
        .then(() => this.$store.dispatch('ActivityDetails/fetch')));
  },
  computed: {
    ...mapState('LandownerReport', {
      landownerReport: state => state.landownerReport,
      loading: state => state.loading,
    }),
    ...mapState('Notification', {
      notificationLoading: state => state.loading,
    }),
    ...mapState('ActivityDetails', {
      activityDetailsLoading: state => state.loading,
    }),
    ...mapGetters('LandownerReport', ['started', 'complete', 'adminEditing']),
  },
};
</script>
